import { Component, Input, OnInit } from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { EntranceSight, TransportCreationProfileSight } from '../../action-tablet-transport-creation-profile.model';
import { ActionItem, AppServerAPI, DialogService } from '@sdbn/common';
import { ActionTabletTransportCreationProfileItemEntranceSelectionComponent, ActionTabletTransportCreationProfileItemEntranceSelectionDialogData } from '../entrance-selection/action-tablet-transport-creation-profile-item-entrance-selection.component';

@Component({
  selector: 'app-action-tablet-transport-creation-profile-item',
  templateUrl: './action-tablet-transport-creation-profile-item.component.html',
  styleUrls: ['./action-tablet-transport-creation-profile-item.component.scss']
})
export class ActionTabletTransportCreationProfileItemComponent implements OnInit {

  @Input() actionItem: ActionItem;

  profiles = new Array<TransportCreationProfileSight>();
  entrances: Array<EntranceSight>;

  constructor(
    private appServerApi: AppServerAPI,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.loadProfiles();
    this.getEntrances();
  }

  handleClick(profile: TransportCreationProfileSight) {

    var data = JSON.parse(this.actionItem.data);

    if (data.entranceIds.length == 1) {
      this.dialogService
        .showConfirm(
          "tmc-yard.ui.action-tablet.create-transport-by-profile.confirm-title",
          "tmc-yard.ui.action-tablet.create-transport-by-profile.confirm-description",
        )
        .afterClosed()
        .subscribe((result) => {
          if (result) {
            this.createTransportByProfileAndEntrance(
              profile.id,
              data.entranceIds[0],
            ).subscribe(() => {});
          }
        });
    } else {
      this.dialogService
        .openDefault(
          ActionTabletTransportCreationProfileItemEntranceSelectionComponent,
          new ActionTabletTransportCreationProfileItemEntranceSelectionDialogData(
            { entrances: this.entrances.filter((entrance) => data.entranceIds.includes(entrance.id)) },
          ),
        )
        .afterClosed()
        .subscribe((result) => {
          console.log("result is", result);
          if (result != null) {
            this.createTransportByProfileAndEntrance(
              profile.id,
              result,
            ).subscribe(() => {});
          }
        });
    }
  }
  
  private createTransportByProfileAndEntrance(profileId: number, entranceId: number): AsyncSubject<void> {
    const subject = new AsyncSubject<void>();
    this.appServerApi.execute('/tmc-yard/control/actionTabletTransportCreationProfile/createTransportByProfileAndEntrance', { profileId: profileId, entranceId: entranceId }).subscribe(response => {
      subject.next();
      subject.complete();
    }, error => {
      subject.error('');
    });
    return subject;
  }

  private loadProfiles(): AsyncSubject<void> {
    
    var data = JSON.parse(this.actionItem.data);

    const subject = new AsyncSubject<void>();
    this.appServerApi.execute<Array<TransportCreationProfileSight>>('/tmc-yard/control/actionTabletTransportCreationProfile/getProfilesByIds', data.profileIds).subscribe(response => {
      let profiles = new Array<TransportCreationProfileSight>();
      for (const transport of response) {
        profiles.push(new TransportCreationProfileSight(transport));
      }
      this.profiles = profiles;
      subject.next();
      subject.complete();
    }, error => {
      subject.error('');
    });
    return subject;
  }

  
  private getEntrances() {
    const subject = new AsyncSubject<void>();
    this.appServerApi.execute<EntranceSight[]>('/tmc-yard/control/actionTabletTransportCreationProfile/getEntrances', {}).subscribe(response => {
      const gates = new Array<EntranceSight>();
      for (const entry of response) {
        gates.push(new EntranceSight(entry));
      }
      this.entrances = gates;
      subject.next();
      subject.complete();
    }, error => {
      subject.error('');
    });
    return subject;
  }

}
